import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Brand } from 'brand';

@Component({
  selector: 'lib-product-card-bullet-list',
  imports: [],
  templateUrl: './product-card-bullet-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardBulletListComponent {
  public brand = input.required<Brand>();
}
